export default "__VITE_ASSET__bd667434__"